import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import linkedIn from "../../assets/linkedInIcon.png";
import linkedInBlue from "../../assets/linkedin.png";
import Cookies from 'js-cookie';

const translations = {
  en: {
    connectLinkedIn: "Connect Your LinkedIn Profile",
    description: "We analyze your online professional presence to enrich your profile and offer deeper insights. Have you already uploaded your resume? Then proceed to the next step now.",
    profileLabel: "LinkedIn Profile",
    placeholder: "Enter URL",
    back: "Back",
    next: "Next",
    invalidUrl: "Please enter a valid LinkedIn URL",
    noValidProfile: "No valid LinkedIn profile found at this URL",
    noData: "No data found for this LinkedIn profile",
    noDataGeneric: "No data found for this LinkedIn profile. Please enter a valid LinkedIn URL."
  },
  nl: {
    connectLinkedIn: "Koppel Je LinkedIn Profiel",
    description: "We analyseren je online professionele aanwezigheid om je profiel te verrijken en diepere inzichten te bieden. Heb je je cv al geüpload? Ga dan nu verder met de volgende stap.",
    profileLabel: "LinkedIn Profiel",
    placeholder: "Voer URL in",
    back: "Terug",
    next: "Volgende",
    invalidUrl: "Voer een geldige LinkedIn-URL in",
    noValidProfile: "Geen geldig LinkedIn-profiel gevonden op deze URL",
    noData: "Geen gegevens gevonden voor dit LinkedIn-profiel",
    noDataGeneric: "Geen gegevens gevonden voor dit LinkedIn-profiel. Voer een geldige LinkedIn-URL in."
  }
};

function LinkedInProfile({setActiveIndicator, linkedInURL, setLinkedInURL, cvFile, mLetterfile, linkedInData, setLinkedInData, isLoading, setIsLoading, setProgress, progress, isDutch}) {
  const location = useLocation();
  const t = translations[isDutch ? 'nl' : 'en'];

  const [error, setError] = useState("");
  const [isValidData, setIsValidData] = useState(false);

  useEffect(() => {
    let interval;
    if (isLoading) {
      interval = setInterval(() => {
        setProgress(prev => {
          if (prev >= 90) return 90; 
          return prev + 10;
        });
      }, 500);
    } else {
      setProgress(0);
    }

    return () => clearInterval(interval);
  }, [isLoading]);

  const validateLinkedInURL = (url) => {
    try {
      const urlWithProtocol = url.startsWith('http://') || url.startsWith('https://') 
        ? url 
        : `https://${url}`;
      const urlObj = new URL(urlWithProtocol);
      return urlObj.hostname.includes('linkedin.com');
    } catch {
      return false;
    }
  };

  const fetchLinkedInData = async (url) => {
    if (!url || !validateLinkedInURL(url)) {
      setIsValidData(false);
      return;
    }

    setIsLoading(true);
    setProgress(0);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/data`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Cookies.get('token')}`
        },
        body: JSON.stringify({ url }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || t.noData);
      }

      const data = await response.json();
      if (data.data) {
        const hasValidData = data.data.firstName || 
                           data.data.lastName || 
                           data.data.headline || 
                           data.data.experience?.length > 0 || 
                           data.data.skills?.length > 0;

        if (hasValidData) {
          setLinkedInData(data.data);
          setIsValidData(true);
          setError("");
          setProgress(100);
        } else {
          setIsValidData(false);
          setError(t.noValidProfile);
        }
      } else {
        setIsValidData(false);
        setError(t.noData);
      }
    } catch (error) {
      setError(t.noDataGeneric);
      setIsValidData(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const url = e.target.value;
    setLinkedInURL(url);
    setError("");
    setIsValidData(false);
    
    if (url) {
      if (!validateLinkedInURL(url)) {
        setError(t.invalidUrl);
      } else {
        fetchLinkedInData(url);
      }
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setActiveIndicator(3);
  };

  const HandleBack = () => {
    setActiveIndicator(1);
  };

    return (
      <div>
        <div className='mb-4'>
          <h1 className="text-5xl font-bold mb-4 text-primary">{t.connectLinkedIn}</h1>
          <p>{t.description}</p>
        </div>
        <div className="border rounded-md p-6 relative">
          <h3 className="text-left mb-4 text-xl font-bold">{t.profileLabel}</h3>
          <span className="flex gap-2 rounded-md items-center">
            <img src={isValidData ? linkedInBlue : linkedIn} className="h-10 flex" alt="LinkedIn icon"/>
            <input 
              type="text" 
              placeholder={t.placeholder}
              value={linkedInURL}
              onChange={handleInputChange}
              className={`w-full py-2 border-bottom ${error ? 'border-red-500' : ''}`}
            />
          </span>
          {error && <p className="text-red-500 mt-2">{error}</p>}
         
        </div>
        <div className="flex gap-2 mt-4 justify-end">
          <button
            className="py-2 px-4 rounded-md border"
            onClick={HandleBack}
          >
            {t.back}
          </button>
          <button
            className={`py-2 px-4 rounded-md bg-buttonColor text-white border`}
            onClick={handleSubmit}
          >
            {t.next}
          </button>
        </div>
      </div>
    );
  }
  
  export default LinkedInProfile;